import React, { Component } from 'react';
import './../styles/landing.scss';

const companies = {
  intelia: "Intelia develops software products for public and private institutions around the globe.",
  google: "Web dashboards to track, assess digital skills training in Sub-Saharan Africa.",
  gloepid: "A Covid-19 risk assessment monitoring web dashboard.",
  squarelabshq: "Squarelabs is a software dev shop company in Nigeria founded by me."
}

class Landing extends Component {
  state = {
    projects: [
      {
        name: "Musically",
        description: "Personal project as a music app experimenting with react spring animations.",
        url: "https://musiclia.firebaseapp.com",
        partners: ["Personal"],
        img: "musicilia.svg",
        stack: ["React Js", "React Spring"]
      },
      {
        name: "Adulthood Immersive Housing Search",
        description: "A platform for immersive housing search exclusively for students in the United States.",
        url: "https://adulthoodinc.com",
        partners: ["Adulthood Inc"],
        img: "adulthood.png",
        stack: ["API", "React Js", "Redux"]
      },
      {
        name: "Airfree ",
        description: "Web application to manage subscriptions to airfree wireless broadband internet.",
        url: "https://airfreeng.herokuapp.com",
        partners: ["Airfree Technologies"],
        img: "airfreeng.png",
        stack: ["API", "React Js", "Redux"]
      }
    ],
    projects2: [
      {
        name: "Covid-19 Dashboard",

        description: "A Covid-19 risk assessment monitoring web dashboard to view the assessment data from the gloepid bot, create and manage cases from the assessment data, view contact tracing data and notify high-risk individuals allowing the NCDC to discover and manage COVID19 cases earlier.",
        url: "https://gloepid.org/",
        partners: ["NCDC", "GloEpid", "Health"],
        img: "virus.png",
        stack: ["API", "React Js", "Redux"]
      },
      {
        name: "GDSA Tracker",
        description: "Several web dashboards with different user-roles (Trainer, Partner, Admin, Googler, Assessor, Assessor Manager) used to track and assess digital skills training in Sub-Saharan Africa. ",
        url: "https://gdsahub.com",
        partners: ["GoogleSSA", "GDSA", "Education"],
        img: "tracker.png",
        stack: ["React Js", "React Spring"]
      }
    ],
  }

  render() {
    return (
      <main className="landing">
        <nav class="navbar navbar-expand-lg fixed-top">
          <a class="navbar-brand" href="#">JD.</a>
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav ml-auto">
              <li class="nav-item">
                <a class="nav-link" href="#">about</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#">portfolio</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#">contact</a>
              </li>
            </ul>
          </div>
        </nav>
        <section className="masthead-section">
          <div className="container-fluid">
            <div className="row row-height align-items-center justify-content-center">
              <div className="col-md-7">
                <p className="hi-text">Hi there <span className="wave"> 👋🏾</span></p>
                <h1 className="intro_text2">I'm John Damilola.</h1>
                <p className="job-title_text">Frontend Engineer, Based in Nigeria 🇳🇬</p>
                <p className="tag-line_text">
                  For 3+ years, I've worked with startups and brilliant companies to design <b>simple</b>, <b>intuitive</b>, and <b>impactful</b> digital products.
                  How can I help you?
                </p>
                <p className="companies_text">I've worked with</p>
                <div className="work">
                  <a href="http://intelia.io/" data-toggle="tooltip" data-placement="top" title={companies.intelia}><span>Intelia | </span></a>
                  <a href="http://gdsahub.com/" data-toggle="tooltip" data-placement="top" title={companies.google}><span>Google SSA | </span></a>
                  <a href="https://www.linkedin.com/company/squarelabshq" data-toggle="tooltip" data-placement="top" title={companies.squarelabshq}><span>Squarelabs | </span></a>
                  <a href="https://gloepid.org/" data-toggle="tooltip" data-placement="top" title={companies.gloepid}><span>GloEpid </span></a>
                </div>

                <a href={require('./../assets/Babalola-Damilola-Frontend-Engineer-Resume.pdf')}>
                  <button className="btn-portfolio">
                    Download Resume
                    <i class="lni lni-download"></i></button>
                </a>

                <p className="companies_text">I'm Available, let's work together</p>
                <div className="socials">
                  <a href="https://www.linkedin.com/in/johndamilola/"><span><i class="lni lni-linkedin-original"></i> LinkedIn</span></a>
                  <a href="https://github.com/JohnDamilola/"><span><i class="lni lni-github-original"></i> GitHub</span></a>
                  <a href="mailto:johndamilola03@gmail.com"><span><i class="lni lni-envelope"></i> johndamilola03@gmail.com</span></a>
                  <a href="tel:+2348141128245"><span><i class="lni lni-phone"></i> +234 814 1128 245</span></a>
                  <a href="https://wa.me/2348141128245?text=Hello%20John%20Damilola"><span><i class="lni lni-whatsapp"></i> Whatsapp</span></a>
                </div>
              </div>
              <div className="col-md-4 left-side d-none d-lg-block">
                <img className="img-fluid" src={require('./../assets/img/myAvatar2.svg')} alt="my pic" />
              </div>
            </div>
          </div>
        </section>

        <section className="project-section normal">
          <div className="container-fluid">
            <div className="row justify-content-center">
              <div className="col-md-10">
                <div className="row">
                  <div className="col-md-12">
                    <p>FEATURED PROJECTS -</p>
                    <h1 className="title">
                      <img className="img-fluid" src={require('./../assets/img/folder.svg')} alt="my pic" /> Stuff I've BUILT
                    </h1>
                  </div>
                </div>
                <div className="row mt-4 equal">
                  {
                    this.state.projects.map(({ name, description, stack, partners, img, url }, i) => {
                      return (
                        <div className="col-xs-6 col-lg-4 mb-4" key={i}>
                          <div className="project-item">
                            <div>
                              <img className="img-fluid mb-3" src={require(`./../assets/img/${img}`)} alt="my pic" />
                              <h2>{name}</h2>
                              <p>{description}</p>
                              <a href={url} target="_blank">
                                <button>View Project</button>
                              </a>
                            </div>
                          </div>
                        </div>
                      )
                    })
                  }
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="project-section collaboration">
          <div className="container-fluid">
            <div className="row justify-content-center">
              <div className="col-md-10">
                <div className="row">
                  <div className="col-md-12">
                    <p>FEATURED COLLABORATIONS -</p>
                    <h1 className="title">
                      <img className="img-fluid" src={require('./../assets/img/folder.svg')} alt="my pic" /> Stuff I've Worked On
                    </h1>
                  </div>
                </div>
                <div className="row mt-4 equal">
                  {
                    this.state.projects2.map(({ name, description, stack, partners, img, url }, i) => {
                      return (
                        <div className="col-xs-6 col-lg-4 mb-4" key={i}>
                          <a href={url} target="_blank">
                            <div className="project-item">
                              <div>
                                <img className="img-fluid mb-3" src={require(`./../assets/img/${img}`)} alt="my pic" />
                                <h2>{name}</h2>
                                <p className="mb-3">{description}</p>
                                {
                                  partners.map((item) => <span className="tag">#{item}</span>)
                                }
                              </div>
                            </div>
                          </a>
                        </div>
                      )
                    })
                  }
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="footer-section">
          <div className="container-fluid">
            <div className="row justify-content-center mb-4">
              <div className="col-md-5">
                <h2>Let’s work together on your next project.</h2>
                <label>EMAIL</label>
                <a><p><u>johndamilola03@gmail.com</u></p></a>
              </div>
              <div className="col-md-5">
              </div>
            </div>
            <div className="row justify-content-center margin-top-lg">
              <div className="col-md-3">
                <h3>JD.</h3>
              </div>
              <div className="col-md-3">
                <h5>Have a great day 😘</h5>
              </div>
              <div className="col-md-4">
                <span className="footer-links">instagram</span>
                <span className="footer-links">github</span>
                <span className="footer-links">dribble</span>
              </div>
            </div>
          </div>
        </section>
      </main>
    )
  }
}

export default Landing;
